export default {
  ja: {
    faq: {
      heading: 'FAQ',
      more: 'さらに表示↓',
      close: '閉じる↑',
      questions: [
        {
          q: '購⼊したチケットのキャンセルや払い戻しはできますか？',
          a: 'キャンセルはできません。',
        },
        {
          q: '再入場は出来ますか？',
          a: '申し訳ございませんが、再入場はできかねます。',
        },
        {
          q: '雨天でも開催していますか？',
          a: '雨天でも開催いたします。天候状況により、コンテンツの内容が変更になる場合がございます。内容変更や中止に際しては、公式Instagramにてお知らせいたします',
        },
        {
          q: 'ベビーカーや車椅子で入場できますか？',
          a: '可能です。場内は、足元が暗くなっている場所や、砂利道や段差もありますのでご注意ください。また、会場内には階段を登らないと閲覧できないコンテンツもありますので、ご了承ください。',
        },
        {
          q: '荷物を預けられますか？',
          a: '申し訳ございませんが、荷物を預ける場所はございませんのでご注意ください。',
        },
        {
          q: '何時に入っても内容は同じですか？',
          a: '演出は何時にご来場いただいても同じものをお楽しみいただけますが、閉場時間間際ですとゆっくり体験いただけない恐れがございます。時間にゆとりを持ってお越しください。',
        },
        {
          q: '何時まで入場できますか？',
          a: '最終入場は20:30、閉門は21:00を予定しています。いかなる場合も時間を延長することはできませんのでご注意ください。',
        },
        {
          q: '食べ歩きはできますか？',
          a: '境内での食べ歩きはできません。駐車場内の花山亭やキッチンカーをご利用ください。',
          hidden: true,
        },
        {
          q: '場内の撮影は可能ですか？',
          a: '金堂華王場殿の内部は撮影いただくことはできません。また三脚、一脚、自撮り棒、ドローンの使用は禁止しております。その他のお客様のご迷惑にならないようご配慮ください。',
        },

      ],
    },
  },
  en: {
    faq: {
      heading: 'FAQ',
      more: 'Show more↓',
      close: 'Close↑',
      questions: [
        {
          q: 'Can I cancel or get a refund for the tickets I purchased?',
          a: 'No, cancellations are not possible.',
        },
        {
          q: 'Can I re-enter?',
          a: 'Re-entry is not permitted.',
        },
        {
          q: 'Will the event take place even in rainy weather?',
          a: 'Yes, the event will take place even in rainy weather. However, the contents may be altered depending on the weather conditions. Any changes or cancellations will be announced on our official Instagram account.',
        },
        {
          q: 'Can I enter with a stroller or wheelchair?',
          a: 'Yes. Please note that the floor may be dark and there may be steps or uneven surfaces within the venue.',
        },
        {
          q: 'Can I check my baggage?',
          a: 'Luggage cannot be checked at this event venue. ',
        },
        {
          q: 'Until what time can I enter the event?',
          a: 'The final admission is at 20:30 and the venue closes at 21:00. Please note that we cannot extend the time under any circumstances.',
        },
        {
          q: 'Are the event\'s contents the same no matter what time I enter?',
          a: 'A	The performances and displays will be the same regardless of your arrival time. However, if you arrive close to closing time, you may not have enough time to fully enjoy the experience. We recommend arriving with plenty of time to explore the venue.',
        },
        {
          q: 'Can I eat while walking around the venue?',
          a: 'No, eating while walking is not allowed.  Please use the designated areas at the Hanayamatei in the parking lot or the food trucks.',
          hidden: true,
        },
        {
          q: 'Can I take pictures inside the venue?',
          a: 'Photography is not allowed inside the Kondo-Keouden. Additionally, the use of tripods, monopods, selfie sticks, and drones is prohibited. Please be mindful not to disturb other guests.',
        },
    ],
    },
  },

};
